import { render, staticRenderFns } from "./ArquivoTable.vue?vue&type=template&id=63f730da&scoped=true"
import script from "./ArquivoTable.vue?vue&type=script&lang=js"
export * from "./ArquivoTable.vue?vue&type=script&lang=js"
import style0 from "./ArquivoTable.vue?vue&type=style&index=0&id=63f730da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f730da",
  null
  
)

export default component.exports